/*
 * zeroLabs Warenkorb (Richtung "Schale"). Zeichnet den Inhalt der Seitenleiste (snippets/zl-warenkorb.liquid) und der
 * Warenkorb-Seite (sections/zl-warenkorb-seite.liquid) aus /cart?view=zl-daten: Pfand getrennt, Versand je Markt,
 * höchstens ein Vorschlag.
 *
 * Was beim Theme bleibt: Öffnen, Schließen, Fokus und Abdunklung der Seitenleiste macht theme.js (theme.Drawers).
 * Hier wird nur gelesen und gezeichnet. Nach jeder eigenen Änderung bekommt theme.js "cart:build", damit die Zahl am
 * Warenkorb-Symbol stimmt. Zum Schließen per Wischen geht "cart:close" an theme.js.
 *
 * Ändern: /cart/change.js mit dem Schlüssel der Zeile. Rückgängig und Dazulegen: /cart/add.js mit Variante und
 * denselben Eigenschaften wie auf der Produktseite (Grundpreis, Lieferung), damit dasselbe Produkt eine Zeile bleibt.
 *
 * Messen: jede Handlung als dataLayer-Ereignis "zl_wk_<aktion>" (Google Tag Manager, Anleitung in docs/tracking.md)
 * und als Shopify-Kundenereignis "zl_warenkorb". Im Test (Theme-Einstellung "test") zusätzlich die Variante.
 * Die Zuteilung zum Test wird nur gespeichert, wenn der Besucher der Analyse zugestimmt hat. Sie gilt sofort auf derselben
 * Seite, wenn der Warenkorb dort noch nicht aufgegangen ist (sofortGelten), sonst ab der nächsten Seite.
 */
(() => {
  const cfg = Object.assign({ modus: 'aus', variante: 'alt', schwelle: 0.67, vorschau: false }, window.zlWk || {});
  if (cfg.modus === 'aus') return;

  const ruhig = matchMedia('(prefers-reduced-motion: reduce)');
  const handy = matchMedia('(max-width: 768px)'); // token-ok: Bruchstelle des Themes
  const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (z) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[z]));
  const ohneMarke = (t) => String(t).replace(/^zeroLabs\s+/, '');
  const wert = (el, name) => getComputedStyle(el).getPropertyValue(name).trim();
  // Zeiten in Millisekunden. Shopify verkürzt beim Ausliefern Millisekunden zu Sekunden, deshalb beide Einheiten lesen
  const zeit = (el, name) => {
    const w = wert(el, name);
    const n = parseFloat(w) || 0;
    return /\ds$/.test(w) && !/ms$/.test(w) ? n * 1000 : n;
  };
  const SORTEN = ['unfiltered', 'future-pilsner', 'futura-hell', 'easy-wheat', 'lemon-infused'];
  const sorteVon = (h) => SORTEN.find((s) => h.includes(s)) || null;
  // Die Erklärung zum Streichpreis ("*Gegenüber UVP …") gehört zur Produktseite, im Vorschlag steht kein Streichpreis
  const ohneSternchen = (html) => String(html).replace(/\s*\*[^<*]*?\([^)]*\)\.?/g, '');
  const istMix = (h) => h.includes('mixpaket') || h.includes('sorten') || h.includes('starterpaket');

  /* ---------- Messen ---------- */
  const gaWarte = [];
  let gaUhr = null;
  function gaSenden(fn) {
    const los = () => { try { fn(); } catch (e) { /* Messen darf den Warenkorb nie stören */ } };
    if (typeof window.gtag === 'function') return los();
    gaWarte.push(los);
    if (gaUhr) return;
    let versuche = 0;
    gaUhr = setInterval(() => {
      versuche += 1;
      if (typeof window.gtag === 'function') { clearInterval(gaUhr); gaWarte.splice(0).forEach((f) => f()); }
      else if (versuche > 40) { clearInterval(gaUhr); gaWarte.length = 0; } // token-ok: höchstens 20 Sekunden warten
    }, 500); // token-ok: alle halbe Sekunde nachsehen
  }

  // Im Test zählt eine Seite nur, wenn sie eine zugeteilte Variante zeigt: Merkmal zl_wk beim Laden (snippets/zl-head.liquid)
  // oder zugeteilt auf dieser Seite, bevor der Warenkorb hier aufging (sofortGelten). Ohne Zuteilung heißt die Variante
  // "ohne", und die Nutzereigenschaft bleibt ungesetzt, damit "alt" nur Zugeteilte zählt.
  let variante = cfg.variante; // was die Seite zeigt: neu oder alt
  let imTest = cfg.modus !== 'test' || cfg.imTest !== false;
  let gruppe = imTest ? variante : 'ohne';
  function melden(aktion, extra = {}) {
    const daten = { wk_variante: gruppe, ...extra };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'zl_wk_' + aktion, ...daten });
    } catch (e) { /* Messen darf den Warenkorb nie stören */ }
    // Direkt an GA4 über das gtag der Seite (Shopifys Google-Anbindung, G-HGF4JK5G5H). Die Einwilligung regelt
    // der Einwilligungsmodus von gtag. Kein Tag im Tag Manager dafür anlegen, sonst kommt jedes Ereignis doppelt an.
    // gtag kommt manchmal erst nach diesem Skript (Shopify lädt die Google-Anbindung nach), dann warten die Ereignisse kurz
    if (cfg.ga4) gaSenden(() => {
      const ga = { send_to: cfg.ga4, ...daten };
      if (imTest) {
        window.gtag('set', 'user_properties', { wk_variante: variante });
        ga.user_properties = { wk_variante: variante };
      }
      if (ga.wk_wert !== undefined) ga.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      window.gtag('event', 'zl_wk_' + aktion, ga);
    });
    try {
      const a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish('zl_warenkorb', { aktion, ...daten });
    } catch (e) { /* ebenso */ }
  }

  /* ---------- Test: Zuteilung nur mit Zustimmung zur Analyse ----------
     Gelost wird bei der Zustimmung oder beim Laden, wenn die Zustimmung schon da ist und noch keine Variante gespeichert.
     Die Variante gilt sofort auf dieser Seite, wenn der Warenkorb hier noch nicht aufgegangen und nichts hineingelegt oder
     geändert ist (tauschbar). Diese Frage wird vor dem Losen gestellt und ist für alt und neu dieselbe, damit beide Gruppen
     gleich gezählt werden. Sonst bleibt die Seite "ohne", und die Variante gilt ab der nächsten Seite. */
  const keks = () => (document.cookie.match(/(?:^|; )zl_wk=(neu|alt)/) || [])[1] || null;
  const hier = { angefasst: false }; // Warenkorb auf dieser Seite geöffnet, befüllt oder geändert
  function zuteilen() {
    if (cfg.modus !== 'test' || keks()) return;
    let erlaubt = false;
    try {
      const p = window.Shopify && window.Shopify.customerPrivacy;
      erlaubt = !!(p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed());
    } catch (e) { erlaubt = false; }
    if (!erlaubt) return;
    const sofort = !imTest && tauschbar();
    const v = Math.random() < 0.5 ? 'neu' : 'alt';
    document.cookie = 'zl_wk=' + v + '; path=/; max-age=7776000; SameSite=Lax'; // token-ok: 90 Tage
    if (sofort) sofortGelten(v);
  }
  // Was der Tausch braucht, wird hier geprüft, damit er bei neu nicht erst nach dem Losen scheitert
  function tauschbar() {
    if (hier.angefasst || variante !== 'alt' || document.body.classList.contains('template-cart')) return false;
    if (document.querySelector('[data-zl-wk="seite"]')) return false;
    const huelle = document.getElementById('CartDrawer');
    const form = document.getElementById('CartDrawerForm');
    const vorlage = document.getElementById('zl-wk-vorlage');
    if (!huelle || !form || form.parentElement !== huelle || !vorlage) return false;
    if (huelle.matches('.drawer--is-open, .is-transitioning') || document.documentElement.classList.contains('js-drawer-closing')) return false;
    return !!vorlage.content.querySelector('#CartDrawer > #CartDrawerForm[data-zl-wk="schale"]');
  }
  /* Tausch nach dem Start von theme.js. theme.js hält die Hülle #CartDrawer (Öffnen, Schließen, Abdunklung, Fokus) und das
     Formular #CartDrawerForm (Fokus beim Öffnen, Zahl am Warenkorb-Symbol). Beide bleiben dieselben Elemente, getauscht
     werden ihre Merkmale und der Inhalt, wie in der Vorlage aus snippets/zl-warenkorb-wahl.liquid. Den Knopf zum Schließen
     kennt theme.js nur aus der alten Liste, der neue schickt deshalb "cart:close" an theme.js. Der Warenkorb ist dabei zu
     (display: none), es springt nichts. */
  function tauschen() {
    const huelle = document.getElementById('CartDrawer');
    const form = document.getElementById('CartDrawerForm');
    const neuHuelle = document.getElementById('zl-wk-vorlage').content.cloneNode(true).querySelector('#CartDrawer');
    const neuForm = neuHuelle.querySelector('#CartDrawerForm');
    const merkmale = (von, nach) => {
      [...nach.attributes].forEach((a) => { if (!von.hasAttribute(a.name)) nach.removeAttribute(a.name); });
      [...von.attributes].forEach((a) => nach.setAttribute(a.name, a.value));
    };
    const leer = huelle.classList.contains('is-empty'); // setzt theme.js nach jedem Neubau, bleibt deshalb stehen
    merkmale(neuHuelle, huelle);
    if (leer) huelle.classList.add('is-empty');
    merkmale(neuForm, form);
    form.replaceChildren(...neuForm.childNodes);
    const zu = form.querySelector('.js-drawer-close');
    if (zu) zu.addEventListener('click', () => document.dispatchEvent(new CustomEvent('cart:close')));
    document.documentElement.classList.remove('zl-wk-alt');
    document.documentElement.classList.add('zl-wk-neu');
    variante = 'neu';
    neuerWarenkorb();
  }
  function sofortGelten(v) {
    if (v === 'neu') {
      try { tauschen(); } catch (e) { return; } // nur bei einem Fehler im Code: die Seite bleibt "ohne"
    }
    imTest = true;
    gruppe = v;
    melden('test', {});
    attributSetzen();
  }
  async function attributSetzen() {
    // Nur auf einer Seite, die die zugeteilte Variante zeigt. Bis dahin bleibt der Warenkorb ohne Merkmal.
    if (cfg.modus !== 'test' || !imTest || keks() !== variante) return;
    try {
      const c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      if (!c.item_count || (c.attributes && c.attributes._zl_warenkorb === variante)) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _zl_warenkorb: variante } })
      });
    } catch (e) { /* ohne Merkmal geht der Kauf trotzdem */ }
  }
  if (cfg.modus === 'test') {
    if (imTest) melden('test', {});
    document.addEventListener('visitorConsentCollected', zuteilen);
    window.addEventListener('load', () => setTimeout(zuteilen, 0));
    document.addEventListener('ajaxProduct:added', attributSetzen);
    window.addEventListener('load', () => setTimeout(attributSetzen, 0));
  }

  /* ---------- Messen in beiden Varianten gleich: Wert beim Öffnen, Zuwachs im offenen Warenkorb, Wert an der Kasse ----------
     Quelle ist für alt und neu dieselbe: der Warenkorb von Shopify (/cart.js), Gesamtpreis samt Pfand in der Währung des
     Markts. Ereignisse (docs/tracking.md):
     - zl_wk_geoeffnet: wk_wert und wk_anzahl beim Öffnen, Seitenleiste (schale) und Warenkorb-Seite (seite)
     - zl_wk_mehr: beim Schließen, Verlassen oder vor der Kasse, wenn der Wert gestiegen ist, solange der Warenkorb offen war.
       wk_zuwachs ist der Zuwachs in dieser Zeit (Plus, Dazu, Rückgängig), wk_wert_vorher der Wert beim Öffnen
     - zl_wk_kasse: wk_wert und wk_anzahl beim Tippen auf Zur Kasse, wk_zuwachs seit dem ersten Öffnen in dieser Sitzung
       (nie unter null) */
  const SITZUNG = 'zl_wk_start';
  const wk = { wert: null, anzahl: 0, offen: false, offenWert: null };
  // Für Menge und Entfernen im bisherigen Warenkorb: Menge je Zeile, wie Shopify sie zuletzt gemeldet hat, und Änderungen,
  // deren Antwort noch aussteht (siehe unten)
  const bekannt = new Map(); // Schlüssel der Zeile: { menge, handle, variante }
  const unterwegs = []; // { key, von, handle, variante, ansicht, zeit }
  function zeilenMerken(c) {
    if (!c || !Array.isArray(c.items)) return;
    const offen = new Set(unterwegs.map((u) => u.key));
    [...bekannt.keys()].forEach((k) => { if (!offen.has(k)) bekannt.delete(k); });
    c.items.forEach((i) => { if (!offen.has(i.key)) bekannt.set(i.key, { menge: i.quantity, handle: i.handle, variante: i.variant_id }); });
  }
  const aufCent = (n) => Math.round(n * 100) / 100; // token-ok: auf Cent gerundet
  async function wertLesen() {
    try {
      const c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      wk.wert = aufCent(c.total_price / 100); // token-ok: Shopify rechnet in Cent
      wk.anzahl = c.item_count;
      zeilenMerken(c);
    } catch (e) { /* ohne Wert misst nur dieser Schritt nicht */ }
    return wk.wert;
  }
  const startWert = () => {
    try { const s = sessionStorage.getItem(SITZUNG); return s === null ? null : parseFloat(s); } catch (e) { return null; }
  };
  async function oeffnen(ansicht) {
    hier.angefasst = true;
    if (wk.offen) return;
    wk.offen = true;
    await wertLesen();
    // Die Warenkorb-Seite zählt nur mit Inhalt, in beiden Varianten gleich: Die bisherige Seite hat leer kein Formular,
    // die neue ist immer da (Moritz, 27.10.2026, neu zählte leere Seiten mit)
    if (ansicht === 'seite' && !wk.anzahl) { wk.offen = false; return; }
    wk.offenWert = wk.wert;
    try { if (sessionStorage.getItem(SITZUNG) === null && wk.wert !== null) sessionStorage.setItem(SITZUNG, String(wk.wert)); } catch (e) { /* ohne Speicher kein Zuwachs bis zur Kasse */ }
    melden('geoeffnet', { wk_ansicht: ansicht, wk_wert: wk.wert ?? 0, wk_anzahl: wk.anzahl });
  }
  function zuwachsMelden() {
    if (!wk.offen) return;
    wk.offen = false;
    if (wk.wert === null || wk.offenWert === null) return;
    const plus = aufCent(wk.wert - wk.offenWert);
    if (plus > 0) melden('mehr', { wk_zuwachs: plus, wk_wert: wk.wert, wk_wert_vorher: wk.offenWert });
  }
  let kasseZuletzt = 0;
  function kasseMelden(ansicht) {
    if (performance.now() - kasseZuletzt < 1000) return; // token-ok: ein Tipp zählt einmal, auch wenn Finger und Taste zusammenkommen
    kasseZuletzt = performance.now();
    const start = startWert();
    const daten = { wk_ansicht: ansicht, wk_wert: wk.wert ?? 0, wk_anzahl: wk.anzahl };
    if (start !== null && wk.wert !== null) daten.wk_zuwachs = Math.max(0, aufCent(wk.wert - start));
    zuwachsMelden();
    melden('kasse', daten);
  }
  // Nach jeder Änderung am Warenkorb (Theme, neuer Warenkorb, Kaufen-Button) den Wert neu lesen, damit er beim Schließen
  // und an der Kasse ohne Warten feststeht. Gelesen wird nur, eingegriffen wird nirgends.
  // Hineinlegen, Ändern oder Leeren zählt auch als angefasst (für sofortGelten), das Merkmal per update nicht.
  try {
    new PerformanceObserver((liste) => {
      const pfade = liste.getEntries().map((e) => new URL(e.name, location.href).pathname + '?');
      if (pfade.some((p) => /\/cart\/(add|change|clear)(\.js)?\?/.test(p))) hier.angefasst = true;
      if (pfade.some((p) => /\/cart\/(add|change|update|clear)(\.js)?\?/.test(p))) wertLesen();
    }).observe({ type: 'resource' });
  } catch (e) { /* ältere Browser: Wert kommt beim nächsten Öffnen */ }
  document.addEventListener('ajaxProduct:added', () => { hier.angefasst = true; });
  document.addEventListener('drawerOpen.CartDrawer', () => oeffnen('schale'));
  const leiste = document.getElementById('CartDrawer');
  if (leiste) {
    new MutationObserver(() => { if (!leiste.classList.contains('drawer--is-open')) zuwachsMelden(); })
      .observe(leiste, { attributes: true, attributeFilter: ['class'] });
  }
  const seiteDa = cfg.variante === 'neu' ? document.querySelector('[data-zl-wk="seite"]') : document.getElementById('CartPageForm');
  if (seiteDa) oeffnen('seite');
  window.addEventListener('pagehide', zuwachsMelden);
  document.addEventListener('pointerdown', (e) => {
    if (e.target.closest('#CartDrawer [name="checkout"], #CartPageForm [name="checkout"], [data-wk-kasse]')) kasseMelden(e.target.closest('#CartDrawer') ? 'schale' : 'seite');
  }, { passive: true });
  document.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('#CartDrawer [name="checkout"], #CartPageForm [name="checkout"], [data-wk-kasse]')) kasseMelden(e.target.closest('#CartDrawer') ? 'schale' : 'seite');
  });

  /* ---------- Bisheriger Warenkorb: Menge und Entfernen messen wie im neuen ----------
     Gelesen wird nur, was theme.js ohnehin meldet: "cart:quantity.<Ort>" mit Zeile und gewünschter Menge (Plus, Minus, Feld),
     danach "cart:updated" mit Shopifys Antwort auf /cart/change.js. Menge vorher (zuletzt von Shopify gemeldet) gegen
     Menge in der Antwort ergibt genau ein Ereignis: 0 heißt zl_wk_entfernt, sonst zl_wk_menge, gleich oder abgelehnt
     heißt keins. Nur solange html zl-wk-alt trägt, damit beim neuen Warenkorb nichts doppelt kommt. */
  const ORT = { 'cart:quantity.cart-cart-drawer': 'schale', 'cart:quantity.cart-header': 'schale', 'cart:quantity.cart-page': 'seite' };
  const UNTERWEGS_HOECHSTENS = 30000; // token-ok: Antwort, die so lange fehlt, kommt nicht mehr (Fehler im Netz)
  Object.keys(ORT).forEach((typ) => document.addEventListener(typ, (e) => {
    hier.angefasst = true;
    if (!document.documentElement.classList.contains('zl-wk-alt')) return;
    const [key, menge] = (e.detail || []);
    if (!key || !menge) return; // so schickt auch theme.js nichts
    const b = bekannt.get(key);
    if (!b) return;
    unterwegs.push({ key, von: b.menge, handle: b.handle, variante: b.variante, ansicht: ORT[typ], zeit: performance.now() });
    b.menge = parseInt(menge, 10) || 0;
  }));
  document.addEventListener('cart:updated', (e) => {
    const jetzt = performance.now();
    while (unterwegs.length && jetzt - unterwegs[0].zeit > UNTERWEGS_HOECHSTENS) unterwegs.shift();
    const u = unterwegs.shift();
    const c = e.detail && e.detail.cart;
    zeilenMerken(c);
    if (!u || !c || !Array.isArray(c.items) || !document.documentElement.classList.contains('zl-wk-alt')) return;
    const zeile = c.items.find((i) => i.key === u.key) || c.items.find((i) => i.variant_id === u.variante && i.handle === u.handle);
    const auf = zeile ? zeile.quantity : 0;
    if (zeile) bekannt.set(zeile.key, { menge: zeile.quantity, handle: zeile.handle, variante: zeile.variant_id });
    if (auf === u.von) return;
    if (auf === 0) melden('entfernt', { wk_produkt: u.handle, wk_menge_von: u.von, wk_ansicht: u.ansicht });
    else melden('menge', { wk_produkt: u.handle, wk_menge_von: u.von, wk_menge_auf: auf, wk_ansicht: u.ansicht });
  });

  /* ---------- Neuer Warenkorb: startet beim Laden, wenn die Seite neu zeigt, oder nach dem Tausch auf der Seite der
     Zustimmung (tauschen). Bei alt bleibt alles beim Theme. ---------- */
  let neuGestartet = false;
  function neuerWarenkorb() {
    if (neuGestartet) return;
    neuGestartet = true;
    const url = (pfad) => (cfg.vorschau && cfg.themeId ? pfad + (pfad.includes('?') ? '&' : '?') + 'preview_theme_id=' + cfg.themeId : pfad);
    async function senden(pfad, body) {
      const r = await fetch(pfad, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    }
    const dazu = (variante, menge = 1, eigenschaften = {}) =>
      senden('/cart/add.js', { items: [{ id: Number(variante), quantity: menge, properties: eigenschaften || {} }] });
    // Shopifys Empfehlungen (intent related) und einzelne Produkte, beide über sections/zl-wk-empfehlung.liquid
    const merker = new Map();
    const holeListe = (pfad) => {
      if (merker.has(pfad)) return merker.get(pfad);
      const versuch = (async () => {
        try {
          const html = await (await fetch(url(pfad))).text();
          const m = html.match(/<script type="application\/json" data-zl-wk-empfehlung>([\s\S]*?)<\/script>/);
          return m ? JSON.parse(m[1]) : [];
        } catch (e) { return []; }
      })();
      merker.set(pfad, versuch);
      return versuch;
    };
    const verwandt = (produktId) => holeListe(`/recommendations/products?product_id=${produktId}&limit=8&intent=related&section_id=zl-wk-empfehlung`);
    // Zum Vergleichen reicht ein 12er (in der Schweiz gibt es keinen, dort bleibt die Empfehlung, wie sie ist)
    const ZWOELFER = {
      'unfiltered': 'zerolabs-unfiltered-12-flaschen',
      'future-pilsner': 'zerolabs-future-pilsner-12-flaschen',
      'futura-hell': 'futura-hell-12-flaschen',
      'easy-wheat': 'easy-wheat-12-flaschen',
      'lemon-infused': 'lemon-infused-12-flaschen'
    };
    const zwoelfer = async (sorte) => (ZWOELFER[sorte] ? (await holeListe(`/products/${ZWOELFER[sorte]}?section_id=zl-wk-empfehlung`))[0] || null : null);

    /* Symbole aus snippets/zl-symbol.liquid (docs/symbole.md): zl-head gibt sie in <template id="zl-symbole"> aus.
       Minus wird bei einem Stück zum Eimer (Regel 9): die Linie des Minus ist der Deckel, Griff und Körper kommen
       aus "loeschen". Im Zustand ist-eins hebt sich der Deckel auf die Kante des Eimers und wird so breit wie sie. */
    const vorlage = document.getElementById('zl-symbole');
    const symbolEl = (n) => (vorlage ? vorlage.content.querySelector(`[data-symbol="${n}"]`) : null);
    const symbol = (n) => { const el = symbolEl(n); return el ? el.outerHTML : ''; };
    const PLUS = symbol('plus');
    const MINUS = (() => {
      const eimer = symbolEl('loeschen');
      const minus = symbolEl('minus');
      if (!eimer || !minus) return symbol('minus');
      const s = eimer.cloneNode(true);
      s.setAttribute('data-symbol', 'minus-loeschen');
      const [deckel, griff, koerper] = s.querySelectorAll('path');
      deckel.setAttribute('d', minus.querySelector('path').getAttribute('d'));
      const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('class', 'zl-wk-eimer__deckel');
      deckel.replaceWith(g);
      g.appendChild(deckel);
      griff.setAttribute('class', 'zl-wk-eimer__griff');
      koerper.setAttribute('class', 'zl-wk-eimer__koerper');
      return s.outerHTML;
    })();

    const LAEDT_NICHT = 'Der Warenkorb lädt gerade nicht. Bitte lade die Seite neu.';

    class Warenkorb {
      constructor(wurzel) {
        this.wurzel = wurzel;
        this.art = wurzel.dataset.zlWk; // schale oder seite
        this.inhalt = wurzel.querySelector('[data-wk-inhalt]');
        this.schale = this.art === 'schale' ? wurzel.closest('#CartDrawer') : null;
        this.daten = null;
        this.entfernt = null;
        this.fehler = '';
        this.alteWerte = {};
        this.altesZiel = null;
        this.gezeigt = '';
        this.beschaeftigt = false;
        this.offen = this.art === 'seite';
        this.empfehlung = null;
        this.binden();
      }

      /* Daten */
      /* Laden zeichnet, sobald die Daten des Warenkorbs da sind. Der Vorschlag braucht weitere Anfragen und kommt danach
         dazu, unter den Posten, ohne dass etwas darüber springt (Moritz, 27.10.2026: Nach dem Hineinlegen stand bis zu
         beidem „Hier steht noch alles auf 0,0.“). Aufrufe aus demselben Moment (Hineinlegen und Öffnen) teilen sich
         eine Anfrage; kommt ein Aufruf, während eine läuft, wird danach noch einmal geladen, damit jede Änderung ankommt. */
      laden() {
        if (this.laeuft) {
          if (!this.gleichzeitig) this.nochmal = true;
          return this.laeuft;
        }
        this.gleichzeitig = true;
        setTimeout(() => { this.gleichzeitig = false; }, 0);
        this.laeuft = (async () => {
          do {
            this.nochmal = false;
            await this.einmalLaden();
          } while (this.nochmal);
        })().finally(() => { this.laeuft = null; this.wartet = false; });
        return this.laeuft;
      }
      async einmalLaden() {
        try {
          const r = await fetch(url('/cart?view=zl-daten'), { cache: 'no-store' });
          this.daten = await r.json();
          this.fehler = this.fehler === LAEDT_NICHT ? '' : this.fehler;
        } catch (e) {
          this.fehler = LAEDT_NICHT;
        }
        if (this.nochmal) return;
        this.wartet = false;
        const schluessel = this.empfehlungSchluessel();
        // Bis der Vorschlag zu neuen Sorten feststeht, steht keiner da: So wechselt er nie sichtbar und wird einmal gezählt.
        // Er wird neben dem Laden geholt, nie davor: Eine Änderung am Warenkorb wartet nie auf ihn.
        if (schluessel !== this.empfehlungFuer) {
          this.empfehlungFuer = schluessel;
          this.empfehlung = null;
          this.vorschlagOffen = true;
          this.vorschlagHolen(schluessel, this.daten);
        }
        this.zeichnen();
      }
      async vorschlagHolen(schluessel, d) {
        let wahl = null;
        try { wahl = await this.empfehlungHolen(d); } catch (e) { wahl = null; }
        if (schluessel !== this.empfehlungFuer) return; // inzwischen andere Sorten, deren eigene Anfrage zählt
        this.empfehlung = wahl;
        this.vorschlagOffen = false;
        // Mitten in einer Änderung zeichnet das Laden danach ohnehin neu, mit dem Vorschlag
        if (!this.beschaeftigt && !this.laeuft) this.zeichnen();
      }
      /* Der Vorschlag hängt nur an den Sorten im Warenkorb und am Land: Ändert sich nur die Menge, bleibt er, ohne neue Anfrage */
      empfehlungSchluessel() {
        const d = this.daten;
        if (!d || !d.posten.length) return '';
        return d.land + '|' + [...new Set(d.posten.map((p) => p.handle))].sort().join(',');
      }
      async empfehlungHolen(d) {
        if (!d || !d.posten.length) return null;
        const biere = d.posten.filter((p) => p.flaschen > 0);
        const sorten = new Set(biere.map((p) => sorteVon(p.handle)).filter(Boolean));
        if (biere.length === 0 || biere.some((p) => istMix(p.handle)) || sorten.size !== 1) return null;
        const liste = await verwandt(biere[0].produkt);
        const andere = liste.filter((v) => v.verfuegbar && !v.handle.includes('b2b') && sorteVon(v.handle) && !sorten.has(sorteVon(v.handle)) && !istMix(v.handle));
        if (!andere.length) return null;
        let wahl = andere.find((v) => v.handle.includes('12-flaschen')) || null;
        if (!wahl && d.land !== 'CH') wahl = await zwoelfer(sorteVon(andere[0].handle));
        return wahl && wahl.verfuegbar ? wahl : andere[0];
      }

      /* Höchstens ein Vorschlag, in dieser Reihenfolge */
      vorschlag() {
        const d = this.daten;
        const hat = (test) => d.posten.some((p) => test(p.handle || ''));
        const kandidat = (teil) => (d.vorschlaege || []).find((v) => v.handle.includes(teil));
        const nichtDrin = (v) => !!v && !hat((h) => h === v.handle) && !(this.entfernt && this.entfernt.posten.handle === v.handle);
        const hatBier = d.posten.some((p) => p.flaschen > 0);
        const hatMix5 = hat((h) => h.includes('mixpaket') && h.includes('5-sorten'));
        const hatLemon = hat((h) => h.includes('lemon-infused'));
        const hatStarter = hat((h) => h.includes('4-sorten'));
        const hatOeffner = hat((h) => /offner|oeffner/.test(h));
        const lemon = d.land !== 'CH' ? kandidat('lemon-infused-12') : null;
        const oeffner = d.land !== 'CH' ? kandidat('offner') : null;
        const lemonErlaubt = nichtDrin(lemon) && !hatMix5 && !hatLemon;
        const oeffnerErlaubt = nichtDrin(oeffner) && !hatOeffner;
        const sorte = this.empfehlung && nichtDrin(this.empfehlung) ? this.empfehlung : null;

        // 1. Starterpaket mit vier Sorten (Deutschland und Österreich): die fünfte dazu
        if (hatStarter && lemonErlaubt) return { ...lemon, satz: 'Fehlt nur noch eine.', regel: 'fuenfte-sorte' };
        // 2. Balken sichtbar und ein Produkt schließt die Lücke: das Günstigste
        if (this.balkenSichtbar() && d.rest_cent > 0) {
          const passt = [oeffnerErlaubt ? oeffner : null, lemonErlaubt ? lemon : null, sorte]
            .filter((v) => v && v.preis_cent >= d.rest_cent)
            .sort((a, b) => a.preis_cent - b.preis_cent)[0];
          if (passt) return { ...passt, satz: 'Damit versandfrei.', regel: 'versand' };
        }
        // 3. Nur eine Sorte im Warenkorb: eine zweite, die Shopify dazu empfiehlt
        if (sorte) return { ...sorte, satz: 'Noch eine Sorte?', regel: 'zweite-sorte' };
        // 4. Bier ohne Öffner (nicht in der Schweiz)
        if (hatBier && oeffnerErlaubt) return { ...oeffner, satz: 'Und zum Öffnen?', regel: 'oeffner' };
        return null;
      }

      balkenSichtbar() {
        const d = this.daten;
        return d && d.anteil !== null && d.anteil !== undefined && (d.frei || d.anteil >= cfg.schwelle);
      }

      /* Bausteine */
      roll(id, w) { return `<span class="zl-wk-roll" data-roll="${esc(id)}"><span>${esc(w)}</span></span>`; }
      menge(p) {
        const eins = p.menge === 1;
        return `<div class="zl-wk-menge${eins ? ' ist-eins' : ''}" data-key="${esc(p.key)}">
          <button type="button" class="zl-wk-menge__knopf" data-wk-minus aria-label="${esc(eins ? ohneMarke(p.titel) + ' entfernen' : 'Eins weniger')}">${MINUS}</button>
          <span class="zl-wk-menge__zahl" aria-live="polite">${this.roll('m' + p.key, p.menge)}</span>
          <button type="button" class="zl-wk-menge__knopf" data-wk-plus aria-label="Eins mehr">${PLUS}</button>
        </div>`;
      }
      lieferGemeinsam() {
        const werte = [...new Set(this.daten.posten.map((p) => p.lieferung).filter(Boolean))];
        return werte.length === 1 ? werte[0] : null;
      }
      posten() {
        const d = this.daten;
        const gemeinsam = this.lieferGemeinsam();
        const zeilen = d.posten.map((p) => `
          <li class="zl-wk-posten__zeile" data-zeile="${esc(p.key)}">
            <a class="zl-wk-posten__bild" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${p.bild ? `<img src="${esc(p.bild)}" alt="" width="72" height="72" loading="lazy">` : ''}</a>
            <div class="zl-wk-posten__info">
              <a class="zl-wk-posten__name" href="${esc(p.url)}">${esc(p.titel)}</a>
              <span class="zl-wk-posten__preis">${this.roll('z' + p.key, p.zeile)}</span>
              ${p.pfand ? `<span class="zl-wk-posten__klein">+ ${this.roll('p' + p.key, p.pfand)} Pfand für ${this.roll('f' + p.key, p.flaschen)} Flaschen</span>` : ''}
              ${p.lieferung && !gemeinsam ? `<span class="zl-wk-posten__klein">Lieferzeit: ${esc(p.lieferung)}</span>` : ''}
            </div>
            <div class="zl-wk-posten__menge">${this.menge(p)}</div>
          </li>`);
        if (this.entfernt) {
          zeilen.splice(Math.min(this.entfernt.index, zeilen.length), 0,
            `<li class="zl-wk-entfernt" data-wk-weg>${esc(ohneMarke(this.entfernt.posten.titel))} entfernt. <button type="button" class="zl-wk-link" data-wk-rueck>Rückgängig</button></li>`);
        }
        if (this.fehler) zeilen.push(`<li class="zl-wk-entfernt" role="alert">${esc(this.fehler)}</li>`);
        return `<ul class="zl-wk-posten">${zeilen.join('')}</ul>`;
      }
      ziel() {
        const d = this.daten;
        if (!this.balkenSichtbar()) return '';
        const text = d.frei ? 'Kostenloser Versand.' : `Noch ${esc(d.rest)} bis zum kostenlosen Versand.`;
        const p = Math.min(1, d.anteil);
        return `<div class="zl-wk-ziel${d.frei ? ' ist-frei' : ''}" data-ziel="${p}">
          <p class="zl-wk-ziel__text" aria-live="polite">${text}</p>
          <span class="zl-wk-ziel__balken" style="--p:${this.altesZiel === null ? p : this.altesZiel}" aria-hidden="true"></span>
        </div>`;
      }
      summe() {
        const d = this.daten;
        const zeilen = [`<div class="zl-wk-summe__zeile"><dt>Artikel</dt><dd>${this.roll('artikel', d.artikel)}</dd></div>`];
        if (d.pfand) zeilen.push(`<div class="zl-wk-summe__zeile"><dt>Pfand</dt><dd>${this.roll('pfand', d.pfand)}</dd></div>`);
        // Groß steht die Zwischensumme ohne Versand, wie im bisherigen Warenkorb. Versand und Gutscheine sagt die Zeile
        // darunter, damit an der Kasse nichts überrascht (Moritz, 27.10.2026: „Gesamt“ mit Versand wirkte teurer).
        zeilen.push(`<div class="zl-wk-summe__zeile zl-wk-summe__zeile--gesamt"><dt>Zwischensumme <span class="zl-wk-summe__zusatz">inkl. MwSt.</span></dt><dd>${this.roll('gesamt', d.zwischensumme)}</dd></div>`);
        const versand = !d.versand ? '' : d.versand === 'frei' ? 'Versand kostenlos. ' : `Zzgl. ${this.roll('versand', d.versand)} Versand. `;
        return `<dl class="zl-wk-summe">${zeilen.join('')}</dl><p class="zl-wk-summe__hinweis">${versand}Gutscheine an der Kasse.</p>`;
      }
      vorschlagHtml() {
        if (this.vorschlagOffen) return '';
        const v = this.vorschlag();
        if (!v) { this.gezeigt = ''; return ''; }
        if (this.offen && this.gezeigt !== v.handle + v.regel) {
          this.gezeigt = v.handle + v.regel;
          melden('vorschlag_gezeigt', { wk_regel: v.regel, wk_produkt: v.handle, wk_ansicht: this.art });
        }
        // Die Hülle misst den Platz (Container), danach richtet sich die Schrift des Vorschlags, nicht nach der Breite des Fensters
        // Der Satz steht über Bild und Text, linksbündig mit dem Bild (Moritz, 22.10.2026)
        return `<div class="zl-wk-vorschlag-platz"><div class="zl-wk-vorschlag">
          <p class="zl-wk-vorschlag__satz">${esc(v.satz)}</p>
          ${v.bild ? `<img src="${esc(v.bild)}" alt="" width="52" height="52" loading="lazy">` : '<span></span>'}
          <div>
            ${(() => {
              // Name wie in Shopify, ohne „zeroLabs“, in zwei festen Zeilen: oben die Sorte oder das Produkt, darunter Menge
              // und Preis. Getrennt wird am Strich im Namen („Lemon Infused – 12 Flaschen“), die Wörter bleiben dieselben.
              const [name, ...rest] = ohneMarke(v.titel).split(/\s+[–-]\s+/);
              return `<p class="zl-wk-vorschlag__name">${esc(name)}</p><p>${rest.length ? esc(rest.join(' ')) + ' ' : ''}${esc(v.preis)}</p>`;
            })()}
          </div>
          <button type="button" class="zl-wk-knopf zl-wk-knopf--zweit" data-wk-vorschlag="${esc(v.handle)}" data-regel="${esc(v.regel)}">Dazu</button>
          ${v.pflicht ? `<div class="zl-wk-vorschlag__pflicht">${ohneSternchen(v.pflicht)}</div>` : ''}
        </div></div>`;
      }
      /* Der Knopf zur Kasse ist ein Element, das jedes Zeichnen an seinen Platz zurücksetzt, statt ihn neu zu bauen:
         Ein Tipp, in dessen Mitte neu gezeichnet wird, kommt so trotzdem an, und der Fokus der Tastatur bleibt. */
      kasse() { return '<span data-wk-kasse-platz></span>'; }
      kasseEl() {
        if (!this.kasseKnopf) {
          const t = document.createElement('template');
          t.innerHTML = '<a class="zl-wk-knopf cart__checkout" href="/checkout" data-wk-kasse>Zur Kasse</a>';
          this.kasseKnopf = t.content.firstElementChild;
        }
        return this.kasseKnopf;
      }
      lieferung() { const l = this.lieferGemeinsam(); return l ? `<p class="zl-wk-lieferung">Lieferzeit: ${esc(l)}</p>` : ''; }
      leer() {
        return `<div class="zl-wk-leer"><p>Hier steht noch alles auf 0,0.</p><a class="zl-wk-knopf" href="${esc(this.wurzel.dataset.leerLink || '/')}">Sorten entdecken</a></div>`;
      }

      /* Zeichnen */
      zeichnen() {
        const d = this.daten;
        let html;
        if (this.wartet && (!d || !d.posten.length) && !this.fehler) {
          // Etwas wurde gerade hineingelegt, die Daten sind unterwegs: eine ruhige leere Fläche statt „0,0“
          html = '<div class="zl-wk-wartet" aria-busy="true"></div>';
        } else if (!d) {
          if (!this.fehler) return;
          html = `<p class="zl-wk-entfernt" role="alert">${esc(this.fehler)}</p>`;
        } else if (!d.posten.length) {
          html = (this.entfernt || this.fehler ? `<div class="zl-wk-mitte">${this.posten()}</div>` : '') + this.leer();
        } else if (this.art === 'seite') {
          html = `<div class="zl-wk-seite__spalten">
            <div>${this.ziel()}${this.posten()}</div>
            <div class="zl-wk-seite__rechts"><div class="zl-wk-seite__summe">${this.summe()}<div class="zl-wk-fuss__knopf">${this.kasse()}</div>${this.lieferung()}</div>${this.vorschlagHtml()}</div>
          </div>`;
        } else {
          html = this.ziel()
            + `<div class="zl-wk-mitte">${this.posten()}${this.vorschlagHtml()}</div>`
            + `<div class="zl-wk-fuss">${this.summe()}<div class="zl-wk-fuss__knopf">${this.kasse()}</div>${this.lieferung()}</div>`;
        }
        // Lage in der Liste und Fokus auf dem Knopf zur Kasse bleiben über das Neuzeichnen erhalten
        // Nach dem Öffnen und Hineinlegen beginnt die Liste oben, dort steht das Neue
        const mitte = this.inhalt.querySelector('.zl-wk-mitte');
        const lage = mitte && !this.vonOben ? mitte.scrollTop : 0;
        this.vonOben = false;
        const knopf = this.kasseKnopf;
        const fokus = !!knopf && document.activeElement === knopf;
        this.inhalt.innerHTML = html;
        const platz = this.inhalt.querySelector('[data-wk-kasse-platz]');
        if (platz) platz.replaceWith(this.kasseEl());
        const mitteNeu = this.inhalt.querySelector('.zl-wk-mitte');
        if (mitteNeu && lage) mitteNeu.scrollTop = lage;
        if (fokus && knopf.isConnected) knopf.focus({ preventScroll: true });
        this.neuerTab();
        this.satzKante();
        // Ändert sich der Platz (Drehen, Fenster), wechselt die Stufe der Schrift, und die Luft vor dem Zeichen wird neu gemessen
        if (window.ResizeObserver) {
          this.kanteWache = this.kanteWache || new ResizeObserver(() => this.satzKante());
          this.kanteWache.disconnect();
          const platz = this.inhalt.querySelector('.zl-wk-vorschlag-platz');
          if (platz) this.kanteWache.observe(platz);
        }
        this.balken();
        this.rollen();
        this.entferntUhr();
      }

      /* Satz über dem Vorschlag und Pflichtangaben darunter stehen mit dem sichtbaren Strich ihres ersten Buchstabens auf
         der Kante des Bilds (CLAUDE.md, Kante). Die Luft vor dem Zeichen misst window.zlTinte an den Pixeln, in jedem
         Browser gleich. */
      satzKante() {
        if (typeof window.zlTinte !== 'function') return;
        // Nur Messen und Ausrichten: ein Fehler hier darf das Zeichnen des Warenkorbs nie aufhalten
        try { this.inhalt.querySelectorAll('.zl-wk-vorschlag__satz, .zl-wk-vorschlag__pflicht').forEach((el) => {
          const gang = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, (n) => (n.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT));
          const knoten = gang.nextNode();
          if (!knoten) return;
          el.style.marginLeft = '';
          const luft = window.zlTinte(knoten.textContent.trim()[0], getComputedStyle(knoten.parentElement));
          if (luft) el.style.marginLeft = `${-luft}px`;
        }); } catch (e) { /* ohne Ausgleich steht der Text höchstens um die Luft vor dem Zeichen neben der Kante */ }
      }

      /* Rechtstexte und Infoseiten (Versandkosten, Datenschutz …) öffnen im neuen Tab, damit der Warenkorb offen bleibt.
         Die Links kommen auch aus Shopify-Feldern (Pflichtangaben), deshalb wird nach jedem Zeichnen nachgesetzt. */
      neuerTab() {
        this.inhalt.querySelectorAll('a[href]').forEach((a) => {
          let ziel;
          try { ziel = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
          const eigen = ziel.origin === location.origin || /(^|\.)zerolabs\.co$/.test(ziel.hostname);
          if (!eigen || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|policies)\//i.test(ziel.pathname)) return;
          a.target = '_blank';
          a.rel = 'noopener';
        });
      }

      /* "… entfernt. Rückgängig" bleibt eine Weile stehen, dann faltet sich die Zeile zusammen und alles darunter
         rückt nach. Liegt Finger, Maus oder Fokus auf der Zeile, hält die Uhr an (Zeit zum Lesen und Tippen). */
      entferntUhr() {
        if (this.uhrHalt) this.uhrHalt();
        this.uhrHalt = null;
        const e = this.entfernt;
        const zeile = this.inhalt.querySelector('[data-wk-weg]');
        if (!e || !zeile) return;
        if (e.rest === undefined) e.rest = zeit(this.wurzel, '--zl-wk-rueck-zeit');
        let uhr = null;
        let start = 0;
        const gehalten = new Set();
        const laufen = () => { if (!uhr && !gehalten.size) { start = performance.now(); uhr = setTimeout(() => this.entferntWeg(e, zeile), e.rest); } };
        const stoppen = () => { if (uhr) { clearTimeout(uhr); uhr = null; e.rest = Math.max(0, e.rest - (performance.now() - start)); } };
        const halten = (grund) => () => { gehalten.add(grund); stoppen(); };
        const loslassen = (grund) => () => { gehalten.delete(grund); laufen(); };
        zeile.addEventListener('pointerenter', halten('zeiger'));
        zeile.addEventListener('pointerleave', loslassen('zeiger'));
        zeile.addEventListener('focusin', halten('fokus'));
        zeile.addEventListener('focusout', loslassen('fokus'));
        this.uhrHalt = stoppen;
        laufen();
      }
      async entferntWeg(e, zeile) {
        if (this.entfernt !== e || !zeile.isConnected) return;
        if (this.beschaeftigt) { e.rest = zeit(this.wurzel, '--zl-wk-zu'); this.entferntUhr(); return; }
        this.uhrHalt = null;
        // Ist der Warenkorb leer, steht die Zeile allein über "Hier steht noch alles auf 0,0." und geht mit ihrem Rahmen
        const liste = zeile.parentElement;
        const allein = liste.children.length === 1;
        const weg = allein ? zeile.closest('.zl-wk-mitte') || zeile : zeile;
        if (!ruhig.matches) {
          const luecke = allein ? 0 : parseFloat(getComputedStyle(liste).rowGap) || 0;
          const rand = zeile === liste.firstElementChild ? 'marginBottom' : 'marginTop';
          const dauer = zeit(this.wurzel, '--zl-wk-zu');
          weg.style.overflow = 'hidden';
          const zu = weg.animate([
            { height: `${weg.offsetHeight}px`, opacity: 1, [rand]: '0px' },
            { height: '0px', opacity: 0, [rand]: `${-luecke}px`, paddingTop: '0px', paddingBottom: '0px' }
          ], { duration: dauer, easing: wert(this.wurzel, '--zl-ease-react') || 'ease-in-out', fill: 'forwards' });
          await Promise.race([zu.finished.catch(() => {}), new Promise((r) => setTimeout(r, dauer + 50))]);
        }
        if (this.entfernt !== e) return;
        this.entfernt = null;
        weg.remove();
      }

      balken() {
        const z = this.inhalt.querySelector('[data-ziel]');
        if (!z) { this.altesZiel = null; return; }
        const neu = parseFloat(z.dataset.ziel);
        const b = z.querySelector('.zl-wk-ziel__balken');
        requestAnimationFrame(() => requestAnimationFrame(() => b.style.setProperty('--p', neu)));
        this.altesZiel = neu;
      }
      rollen() {
        const zahl = (t) => parseFloat(String(t).replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
        const neu = {};
        this.inhalt.querySelectorAll('[data-roll]').forEach((el) => {
          const id = el.dataset.roll;
          const w = el.textContent;
          if (neu[id] === undefined) neu[id] = w;
          if (ruhig.matches || this.alteWerte[id] === undefined || this.alteWerte[id] === w) return;
          const hoch = zahl(w) > zahl(this.alteWerte[id]);
          el.firstElementChild.animate(
            [{ transform: hoch ? 'translateY(100%)' : 'translateY(calc(100% * -1))', opacity: 0 }, { transform: 'none', opacity: 1 }],
            { duration: zeit(this.wurzel, '--zl-wk-rollen'), easing: wert(this.wurzel, '--zl-ease-react') || 'ease-out' }
          );
        });
        this.alteWerte = neu;
      }

      /* Ereignisse */
      binden() {
        this.inhalt.addEventListener('click', (e) => this.klick(e));
        // Drücken wie bei der Menge neben dem Kaufen-Button: kurzes Rütteln, wo das Telefon es kann
        this.inhalt.addEventListener('pointerdown', (e) => {
          if (!e.target.closest('.zl-wk-menge__knopf, .zl-wk-knopf--zweit')) return;
          try { if (navigator.vibrate) navigator.vibrate(8); } catch (err) { /* ohne Rütteln */ } // token-ok: ein kurzer Tick
        }, { passive: true });
        this.inhalt.addEventListener('keydown', (e) => {
          const k = e.target.closest && e.target.closest('.zl-wk-menge__knopf, .zl-wk-knopf--zweit');
          if (!k || (e.key !== 'Enter' && e.key !== ' ')) return;
          k.classList.add('ist-gedrueckt');
          setTimeout(() => k.classList.remove('ist-gedrueckt'), 150); // token-ok: so lang wie ein Druck
        });
        if (this.schale) {
          document.addEventListener('drawerOpen.CartDrawer', () => {
            this.offen = true;
            this.gezeigt = '';
            this.vonOben = true;
            this.laden();
          });
          // theme.js meldet nur das Öffnen, geschlossen ist die Schale, wenn die Klasse drawer--is-open fehlt
          new MutationObserver(() => { this.offen = this.schale.classList.contains('drawer--is-open'); })
            .observe(this.schale, { attributes: true, attributeFilter: ['class'] });
          document.addEventListener('ajaxProduct:added', () => {
            this.entfernt = null;
            this.fehler = '';
            this.wartet = true;
            this.vonOben = true;
            this.zeichnen();
            this.laden();
          });
          this.ziehen();
        }
      }
      async klick(e) {
        const t = e.target.closest('button, a');
        if (!t) return;
        if (t.matches('[data-wk-kasse]')) return; // gemessen oben, für beide Varianten gleich
        const aktion = t.matches('[data-wk-vorschlag], [data-wk-rueck], [data-wk-minus], [data-wk-plus]');
        if (!aktion || this.beschaeftigt) return;
        this.beschaeftigt = true;
        this.fehler = '';
        const d = this.daten;
        try {
          if (t.matches('[data-wk-vorschlag]')) {
            const v = [...(d.vorschlaege || []), this.empfehlung].find((x) => x && x.handle === t.dataset.wkVorschlag);
            t.classList.add('ist-laedt');
            await dazu(v.variante, 1, v.eigenschaften);
            melden('vorschlag_dazu', { wk_regel: t.dataset.regel, wk_produkt: v.handle, wk_ansicht: this.art });
          } else if (t.matches('[data-wk-rueck]')) {
            const e2 = this.entfernt;
            t.disabled = true;
            t.textContent = 'Wird zurückgelegt';
            await dazu(e2.posten.variante, e2.posten.menge, e2.posten.eigenschaften);
            this.entfernt = null;
            melden('rueckgaengig', { wk_produkt: e2.posten.handle, wk_ansicht: this.art });
          } else {
            const feld = t.closest('.zl-wk-menge');
            const index = d.posten.findIndex((x) => x.key === feld.dataset.key);
            const p = d.posten[index];
            if (p) {
              const neu = p.menge + (t.matches('[data-wk-plus]') ? 1 : -1);
              feld.classList.add('ist-laedt');
              if (neu < 1) {
                const zeile = t.closest('[data-zeile]');
                if (zeile && !ruhig.matches) {
                  zeile.style.overflow = 'hidden';
                  const dauer = zeit(this.wurzel, '--zl-wk-zu');
                  // Die Zeile schrumpft auf die Höhe der Meldung "… entfernt. Rückgängig", die an ihren Platz tritt: nichts springt nach
                  const probe = document.createElement('li');
                  probe.className = 'zl-wk-entfernt';
                  probe.style.cssText = 'position:absolute;visibility:hidden;inset-inline:0';
                  probe.innerHTML = `${esc(ohneMarke(p.titel))} entfernt. <button type="button" class="zl-wk-link">Rückgängig</button>`;
                  zeile.parentElement.style.position = 'relative';
                  zeile.parentElement.appendChild(probe);
                  const platz = Math.min(zeile.offsetHeight, probe.offsetHeight);
                  probe.remove();
                  zeile.parentElement.style.position = '';
                  const zu = zeile.animate([{ height: `${zeile.offsetHeight}px`, opacity: 1 }, { height: `${platz}px`, opacity: 0 }],
                    { duration: dauer, easing: wert(this.wurzel, '--zl-ease-react') || 'ease-in-out', fill: 'forwards' });
                  // Nie auf die Bewegung warten müssen: im Hintergrund-Tab steht sie still, der Warenkorb darf es nicht
                  await Promise.race([zu.finished.catch(() => {}), new Promise((r) => setTimeout(r, dauer + 50))]);
                }
                await senden('/cart/change.js', { id: p.key, quantity: 0 });
                this.entfernt = { posten: p, index };
                melden('entfernt', { wk_produkt: p.handle, wk_menge_von: p.menge, wk_ansicht: this.art });
              } else {
                await senden('/cart/change.js', { id: p.key, quantity: neu });
                this.entfernt = null;
                melden('menge', { wk_produkt: p.handle, wk_menge_von: p.menge, wk_menge_auf: neu, wk_ansicht: this.art });
              }
            }
          }
        } catch (err) {
          this.fehler = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
        } finally {
          this.beschaeftigt = false;
        }
        await this.laden();
        document.dispatchEvent(new CustomEvent('cart:build')); // theme.js aktualisiert die Zahl am Warenkorb-Symbol
        if (this.art === 'seite') document.dispatchEvent(new CustomEvent('zl-wk:geaendert'));
      }

      /* Am Handy die Schale am Kopf nach unten wegziehen */
      ziehen() {
        let zug = null;
        const s = this.schale;
        s.addEventListener('pointerdown', (e) => {
          if (!handy.matches || !e.target.closest('[data-wk-ziehen], .zl-wk-griff') || e.target.closest('button')) return;
          zug = { y: e.clientY, t: performance.now(), dy: 0 };
          s.classList.add('ist-gezogen');
        });
        addEventListener('pointermove', (e) => {
          if (!zug) return;
          zug.dy = Math.max(0, e.clientY - zug.y);
          s.style.transform = `translateY(${zug.dy}px)`;
        }, { passive: true });
        const los = () => {
          if (!zug) return;
          const tempo = zug.dy / Math.max(1, performance.now() - zug.t);
          s.classList.remove('ist-gezogen');
          s.style.transform = '';
          if (zug.dy > s.offsetHeight / 4 || tempo > 0.5) {
            melden('geschlossen_wischen', {});
            document.dispatchEvent(new CustomEvent('cart:close'));
          }
          zug = null;
        };
        addEventListener('pointerup', los);
        addEventListener('pointercancel', los);
      }
    }

    /* ---------- Regler im Vorschau-Theme (?zl-wk-regler) ---------- */
    function regler(alle) {
      if (!cfg.vorschau || !new URLSearchParams(location.search).has('zl-wk-regler')) return;
      const feld = document.createElement('details');
      feld.className = 'zl-wk-regler';
      feld.open = true;
      feld.innerHTML = `<summary>Warenkorb</summary>
        <label>Balken ab <output data-a></output> des Wegs<input type="range" min="0" max="1" step="0.01" value="${cfg.schwelle}" data-r="schwelle"></label>
        <label>Tempo der Schale <output data-b></output><input type="range" min="250" max="800" step="10" value="${zeit(document.documentElement, '--zl-wk-schale-dauer')}" data-r="dauer"></label>`;
      document.body.appendChild(feld);
      const a = feld.querySelector('[data-a]');
      const b = feld.querySelector('[data-b]');
      const zeigen = () => {
        a.textContent = Math.round(cfg.schwelle * 100) + ' %';
        b.textContent = wert(document.documentElement, '--zl-wk-schale-dauer');
      };
      feld.addEventListener('input', (e) => {
        if (e.target.dataset.r === 'schwelle') { cfg.schwelle = parseFloat(e.target.value); alle.forEach((w) => w.zeichnen()); }
        if (e.target.dataset.r === 'dauer') document.documentElement.style.setProperty('--zl-wk-schale-dauer', e.target.value + 'ms');
        zeigen();
      });
      zeigen();
    }

    /* ---------- Start ---------- */
    const start = () => {
      const alle = [...document.querySelectorAll('[data-zl-wk]')].map((w) => new Warenkorb(w));
      const laden = () => alle.forEach((w) => w.laden());
      if (document.querySelector('[data-zl-wk="seite"]') || document.body.classList.contains('cart-has-items')) laden();
      else if ('requestIdleCallback' in window) requestIdleCallback(laden);
      else setTimeout(laden, 1);
      regler(alle);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
  if (variante === 'neu') neuerWarenkorb();
})();
